import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "./app-routes";

const Content = () => {
  return (
    <React.Fragment>
      <Switch>
        {routes.map(({ path, component }) => (
          <Route exact key={path} path={path} component={component} />
        ))}
        <Redirect to={"/overview-short-report"} />
      </Switch>
    </React.Fragment>
  );
};

export default Content;
